import app from 'flarum/forum/app';

export default function () {
  // Save the original function before we override it
  const original_discussion_route = app.route.discussion;

  /**
   * Generate a URL to a discussion OR a knowledge base Article.
   *
   * CORE_CODE_OVERRIDE: This overrides the standard function from flarum/core.
   * The code is inspired from js/src/forum/routes.js and now handles different types of discussions.
   * It will try to keep the original function executed if the discussion being
   * processed isn't a support knowledge base article.
   *
   * @param {Discussion} discussion
   * @param {Integer} [near]
   * @return {String}
   */
  app.route.discussion = (discussion, near) => {
    const discussionRedirectEnabled =
      app.forum.attribute('support_knowledge_base_redirects_enabled') === 'both' ||
      app.forum.attribute('support_knowledge_base_redirects_enabled') === 'discussions_only';
    let shouldRedirect = false;
    if (discussionRedirectEnabled && discussion.tags && discussion.tags().length > 0) {
      const supportTags = app.forum.attribute('support_knowledge_base_tags');

      const foundTags = discussion.tags().filter((tag) => {
        return supportTags.indexOf(tag.id()) >= 0 || (tag.parent() && supportTags.indexOf(tag.parent().id()) >= 0);
      });

      if (foundTags.length > 0) {
        shouldRedirect = true;
      }
    }
    if (shouldRedirect) {
      return discussion.lastReadPostNumber() > 1
        ? app.route('knowledgeBaseArticle.near', {
            id: discussion.slug(),
            near: discussion.lastReadPostNumber(),
          })
        : app.route('knowledgeBaseArticle', {
            id: discussion.slug(),
          });
    } else {
      return original_discussion_route(discussion, near);
    }
  };
}
